import "./style.scss";
import Modal from "bootstrap/js/dist/modal";
import { Input } from "./edit-menu";
import { Editor } from "./editor";
import * as documentImport from "./import";
import { LocalBackend } from "./local-backend";
import * as project from "./project";
import { ProjectStore } from "./store";
import {
  AbleitungsmodifikationenRepraesentation,
  AbleitungsmodifikationenStruktur,
  DEFAULT_DOCUMENT_PROFILE,
  FreigabeStatus,
  xdf2,
  xdf3,
} from "./xdatenfelder";

type SelectSchemaCallback = (identifier: project.Identifier) => void;

function renderPicker(
  backend: LocalBackend,
  onSelectSchema: SelectSchemaCallback,
): HTMLElement {
  let onlyArbeitskopien = false;

  const root = document.createElement("div");
  root.innerHTML = `
    <div class="d-flex flex-row align-items-center gap-3 text-white bg-dark p-3">
        <i class="bi bi-chat-fill fs-5 ps-2"></i>
        <span><strong>Du hast Feedback zum Editor oder benötigst Hilfe?</strong> Schreibe uns eine Nachricht. Gerne machen wir auch einen Termin für einen persönlichen Videocall.</span>
        <a href="mailto:info@x-gov.de" class="btn btn-outline-light ms-auto text-nowrap">Kontaktiere uns <i class="bi bi-envelope-fill ms-2"></i></a>
    </div>
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid d-flex justify-content-end">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" href="/datenschutz">Datenschutz</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/impressum">Impressum</a>
          </li>
        </ul>
      </div>
    </nav>
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-12 col-lg-8">
          <div class="text-start">
              <h1 class="display-4 mb-4 d-flex flex-row align-items-start gap-2">XDatenfelder 3 Editor (BETA)
              </h1>
              <p class="mb-4 text-muted">
                Erstelle und bearbeite XDatenfelder Schemata direkt auf deinem Computer.
                Alle Daten werden lokal im Browser gespeichert und nicht an den Server gesendet.
              </p>
          </div>

          <div class="row mb-3 g-3">
            <div class="col-12 col-lg-4 d-flex flex-column">
              <a href="#" id="create-new" class="card card-link">
                <div class="card-body text-start d-flex flex-row align-items-center gap-3">
                  <i class="bi bi-plus-square fs-4 d-block"></i>
                  <div class="d-flex flex-column align-items-start">
                    <h2 class="fs-6 mb-1">Erstellen</h2>
                    <span class="text-muted small">Erstelle ein neues Schema lokal auf deinem Computer.</span>
                  </div>
                </div>
              </a>
            </div>

            <div class="col-12 col-lg-4 d-flex flex-column">
              <a href="#" id="portal-import" class="card card-link">
                <div class="card-body text-start d-flex flex-row align-items-center gap-3">
                  <i class="bi bi-cloud-download fs-4 d-block"></i>
                  <div class="d-flex flex-column align-items-start">
                    <h2 class="fs-6 mb-1">Importieren</h2>
                    <span class="text-muted small">Importiere ein Datenschema aus dem FIM Portal.</span>
                  </div>
                </div>
              </a>
            </div>

            <div class="col-12 col-lg-4 d-flex flex-column">
              <a href="#" id="import-xdf" class="card card-link">
                <div class="card-body text-start d-flex flex-row align-items-center gap-3">
                  <i class="bi bi-upload fs-4 d-block"></i>
                  <div class="d-flex flex-column align-items-start">
                    <h2 class="fs-6 mb-1">Hochladen</h2>
                    <span class="text-muted small">Lade ein XDF2 oder XDF3 Datenschema hoch.</span>
                  </div>
                </div>
              </a>
            </div>
          </div>

          
          <div class="card card-body mb-5">
            <h2 class="fs-5 mb-3">Meine lokalen Daten</h2>

            <div class="d-flex flex-row align-items-center gap-3 text-warning-emphasis bg-warning-subtle border border-warning-subtle py-2 px-3 rounded-3 mb-3">
              <i class="bi bi-exclamation-triangle fs-4 d-block"></i>
              <span>
                <strong>Deine Daten werden nur lokal im Browser gespeichert.</strong><br />
                Wenn sich der Browser zurücksetzt oder du den Cache löschst, gehen alle Daten verloren.
              </span>
            </div>

            <div class="d-flex flex-row align-items-center mb-3 gap-5">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" checked id="only-arbeitskopien">
                <label class="form-check-label" for="only-arbeitskopien">
                  Nur Arbeitskopien anzeigen
                </label>
              </div>
            </div>

            <ul id="project-list" class="list-group border-0"></ul>
          </div>

          <hr class="my-5" />
          <div>
            <h2 class="fs-3 mb-3"><i class="bi bi-question-circle me-2 text-muted"></i> Häufige Fragen</h2>
            <div class="list-group mb-3">
            <div class="list-group-item p-3">
                <h3 class="fs-5 mb-2">
                  Wie sicher sind meine Daten?
                </h3>
                <p class="mb-0">
                  Der Editor speichert alle Daten ausschließlich lokal in deinem Browser, es erfolgt keine Übertragung an einen Server. Dadurch bleiben deine Daten vollständig auf deinem Gerät. Allerdings bedeutet die lokale Speicherung auch, dass Daten verloren gehen können, wenn du den Browser-Cache leerst, im Inkognito-Modus arbeitest oder den Browser bzw. das Gerät wechselst. Da es sich um eine BETA-Version handelt, kann es zudem noch zu Änderungen oder Fehlern kommen.
                </p>
              </div>
              <div class="list-group-item p-3">
                <h3 class="fs-5 mb-2">
                  Warum werden noch keine XDatenfelder 3.0.0 Daten aus dem FIM Portal unterstützt?
                </h3>
                <p class="mb-0">
                  Im FIM Portal gibt es aktuell nur sehr wenige Daten im Format XDatenfelder 3.0.0.
                  Daher haben wir uns entschieden, in der Beta-Phase auf die vorhandenen XDatenfelder 2.0 Daten zurückzugreifen.
                  Da unser Editor auf Basis von XDatenfelder 3.0.0 arbeitet, werden alle Daten beim Import automatisch zu XDatenfelder 3.0.0
                  konvertiert.
                  Damit kann in der Beta-Phase bereits auf die große Menge vorhandener XDatenfelder 2.0 Daten zurückgegriffen werden.
                  Sobald es im FIM Portal eine ausreichende Menge an Daten im Format XDatenfelder 3.0.0 gibt, werden wir den Import umstellen. 
                </p>
              </div>
            </div>
            <div class="d-flex flex-row align-items-center gap-3 text-primary-emphasis bg-primary-subtle border border-primary-subtle p-3 rounded-2 mb-5">
              <i class="bi bi-chat fs-5 ps-2"></i>
              <span><strong>Du hast weitere Fragen zum Editor?</strong><br /> Schreibe uns eine Nachricht. Gerne machen wir auch einen Termin für einen persönlichen Videocall.</span>
              <a href="mailto:info@x-gov.de" class="btn btn-primary ms-auto text-nowrap">Kontaktiere uns <i class="bi bi-envelope-fill ms-2"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    `;

  const newSchemaModal = new NewProjectModal();
  root.appendChild(newSchemaModal.root);

  const importXDFModal = new ImportXDFModal();
  root.appendChild(importXDFModal.root);

  const importPortalModal = new ImportPortalModal();
  root.appendChild(importPortalModal.root);

  const onDeleteSchema = (identifier: project.Identifier) => {
    backend.deleteSchema(identifier.fimId, identifier.fimVersion);
  };

  const schemaList = root.querySelector("#project-list")!;
  function updateList() {
    const schemas = backend
      .loadSchemas()
      .filter((schema) => !onlyArbeitskopien || schema.type === "arbeitskopie");
    if (schemas.length === 0) {
      schemaList.innerHTML = `
              <li class="list-group-item text-muted">Sobald du ein Schema erstellst oder hochlädst, erscheint es hier.</li>
            `;
    } else {
      schemaList.replaceChildren(
        ...schemas.map((schema) =>
          renderSchema(schema, onSelectSchema, onDeleteSchema),
        ),
      );
    }
  }

  updateList();

  const onlyArbeitskopienCheckbox = root.querySelector(
    "#only-arbeitskopien",
  ) as HTMLInputElement;
  onlyArbeitskopienCheckbox.checked = onlyArbeitskopien;

  onlyArbeitskopienCheckbox.addEventListener("change", () => {
    if (onlyArbeitskopienCheckbox.checked) {
      onlyArbeitskopien = true;
    } else {
      onlyArbeitskopien = false;
    }

    updateList();
  });

  const createButton = root.querySelector("#create-new")!;
  createButton.addEventListener("click", () => {
    newSchemaModal.open((schemaId) => {
      const schema: project.SchemaArbeitskopie = {
        type: "arbeitskopie",
        fimId: schemaId,
        basicData: {
          name: "Neues Schema",
          beschreibung: undefined,
          definition: undefined,
          normReferences: [],
          releaseStatus: FreigabeStatus.InBearbeitung,
          statusGesetztAm: undefined,
          statusGesetztDurch: undefined,
          gueltigAb: undefined,
          gueltigBis: undefined,
          versionshinweis: undefined,
          veroeffentlichungsdatum: undefined,
          relations: [],
          keywords: [],
        },
        bezeichnung: undefined,
        hilfeText: undefined,
        ableitungsModifikationenRepraesentation:
          AbleitungsmodifikationenRepraesentation.Modifizierbar,
        ableitungsModifikationenStrutkur:
          AbleitungsmodifikationenStruktur.AllesModifizierbar,
        documentSteckbriefFimId: DEFAULT_DOCUMENT_PROFILE,
        children: [],
        rules: [],
      };

      backend.saveSchema(schema);
      onSelectSchema(schema);
    });
  });

  const importXDFButton = root.querySelector("#import-xdf")!;
  importXDFButton.addEventListener("click", () => {
    importXDFModal.open((schemaImport) => {
      backend.saveSchemaDocument(schemaImport);
      onSelectSchema(schemaImport.schema);
    });
  });

  const importPortalButton = root.querySelector("#portal-import")!;
  importPortalButton.addEventListener("click", () => {
    importPortalModal.open((schemaImport) => {
      backend.saveSchemaDocument(schemaImport);

      onSelectSchema(schemaImport.schema);
    });
  });

  //const importRedaktionButton = root.querySelector("#import-redaktion")!;
  //importRedaktionButton.addEventListener("click", () => {
  //onStartRedaktionsImport();
  //});

  return root;
}

function renderSchema(
  schema: project.Schema,
  onSelectSchema: SelectSchemaCallback,
  onDeleteSchema: SelectSchemaCallback,
): HTMLElement {
  const root = document.createElement("li");
  root.classList.add(
    "list-group-item",
    "d-flex",
    "flex-row",
    "justify-content-between",
    "align-items-center",
    "gap-2",
  );
  root.setAttribute("data-id", schema.fimId);
  root.innerHTML = `
      <div class="d-flex flex-column align-items-start gap-0">
        <h6 class="mb-0"></h6>
        <span class="text-secondary"></span>
      </div>
      <div class="d-flex flex-row gap-1">
        <a id="edit" href="#" class="btn btn-light link-primary"><i class="bi bi-pencil"></i></a>
        <a id="delete" href="#" class="btn btn-light link-danger"><i class="bi bi-trash"></i></a>
      </div>
    `;

  const header = root.querySelector("h6")!;
  header.innerHTML = schema.basicData.name;

  const subheader = root.querySelector("span")!;
  if (schema.type === "arbeitskopie") {
    subheader.textContent = schema.fimId;
  } else {
    subheader.textContent = `${schema.fimId} Version ${schema.fimVersion}`;
  }

  const editButton = root.querySelector("#edit")! as HTMLAnchorElement;
  editButton.addEventListener("click", (event) => {
    event.preventDefault();
    onSelectSchema(schema);
  });

  const deleteButton = root.querySelector("#delete")! as HTMLAnchorElement;
  deleteButton.addEventListener("click", (event) => {
    event.preventDefault();

    if (
      confirm(
        `Möchtest du das Schema "${schema.basicData.name}" wirklich löschen?`,
      )
    ) {
      root.remove();
      onDeleteSchema(schema);
    }
  });

  return root;
}

async function loadFile(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      if (event.target === null) {
        return reject("Target is none");
      }
      const { result } = event.target;

      if (typeof result !== "string") {
        console.error(result);
        return reject("Unknown file content");
      }

      resolve(result);
    };

    reader.onerror = (event) => {
      reject(event.target?.error);
    };

    reader.readAsText(file, "utf-8");
  });
}

type ImportSchemaCallback = (schemaDocument: project.SchemaDocument) => void;

class ImportXDFModal {
  readonly root: HTMLElement;

  private fileInput: HTMLInputElement;

  private modal: Modal;
  private onFinish: ImportSchemaCallback | undefined = undefined;

  constructor() {
    this.root = document.createElement("div");
    this.root.classList.add("modal");
    this.root.setAttribute("aria-hidden", "true");
    this.root.setAttribute("tabindex", "-1");

    this.root.innerHTML = `
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <form>
                        <div class="modal-header">
                            <h5 class="modal-title">XDatenfelder Schema hochladen</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-3">
                              <label for="xdf-file" class="form-label">Wähle eine XDatenfelder-Datei aus:</label>
                              <input
                                id="xdf-file"
                                class="form-control"
                                type="file"
                                required
                                accept=".xml"
                              />
                              <div class="form-text">
                                XDatenfelder 2.0 wird automatisch zu XDatenfelder 3.0.0 konvertiert.
                              </div>
                            </div>
                            <div id="file-error" class="invalid-feedback" role="alert"></div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Abbrechen</button>
                            <button type="submit" class="btn btn-primary">Hochladen</button>
                        </div>
                    </form>
                </div>
            </div
        `;

    this.fileInput = this.root.querySelector("#xdf-file") as HTMLInputElement;

    const form = this.root.querySelector("form")!;
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      this.import();
    });

    this.modal = new Modal(this.root);
  }

  private showError(message: string) {
    const errorDiv = this.root.querySelector("#file-error") as HTMLElement;
    errorDiv.textContent = message;
    this.fileInput.classList.add("is-invalid");
  }

  private clearError() {
    const errorDiv = this.root.querySelector("#file-error") as HTMLElement;
    errorDiv.textContent = "";
    this.fileInput.classList.remove("is-invalid");
  }

  private async import() {
    const { files } = this.fileInput;
    if (files === null || files.length === 0) {
      return;
    }

    this.clearError();
    this.fileInput.setAttribute("disabled", "true");

    let schemaDoc: project.SchemaDocument;
    try {
      const file = files[0];
      const data = await loadFile(file);

      // Detect XDF version from namespace
      if (data.includes(xdf3.NAMESPACE)) {
        const message = xdf3.parseSchemaMessage(data);
        schemaDoc = documentImport.xdf3.createSchemaDocument(message);
      } else {
        const message = xdf2.SchemaMessage.fromString(data);
        schemaDoc = documentImport.xdf2.createSchemaDocument(message, {});
      }
    } catch (error) {
      console.error(error);
      this.fileInput.removeAttribute("disabled");
      this.showError(
        error instanceof Error
          ? error.message
          : "Ein unbekannter Fehler ist aufgetreten",
      );
      return;
    }

    this.modal.hide();

    const onFinish = this.getOnFinish();
    onFinish(schemaDoc);
  }

  private getOnFinish(): ImportSchemaCallback {
    // This should be impossible
    if (this.onFinish === undefined) {
      throw new Error("onFinish is undefined");
    }

    return this.onFinish;
  }

  public open(onFinish: ImportSchemaCallback) {
    this.onFinish = onFinish;

    this.fileInput.value = "";
    this.modal.show();
  }
}

type NewProjectCallback = (id: string) => void;

class NewProjectModal {
  readonly root: HTMLElement;

  private nummernkreisInput: Input;
  private unternummernkreisInput: Input;
  private idInput: Input;

  private modal: Modal;
  private onFinish: NewProjectCallback | undefined = undefined;

  constructor() {
    this.root = document.createElement("div");
    this.root.classList.add("modal");
    this.root.setAttribute("aria-hidden", "true");
    this.root.setAttribute("tabindex", "-1");

    this.root.innerHTML = `
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <form>
                        <div class="modal-header">
                            <h5 class="modal-title">Neues Datenschema erstellen</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Abbrechen</button>
                            <button type="submit" class="btn btn-primary">Erstellen</button>
                        </div>
                    </form>
                </div>
            </div
        `;

    const body = this.root.querySelector(".modal-body") as HTMLElement;

    this.nummernkreisInput = new Input(
      "Nummernkreis",
      "",
      "Eine Zahl zwischen 0 und 99",
    );
    body.append(this.nummernkreisInput.root);

    this.unternummernkreisInput = new Input(
      "Unternummernkreis",
      "000",
      "Eine Zahl zwischen 0 und 999",
    );
    body.append(this.unternummernkreisInput.root);

    this.idInput = new Input("ID", "", "Eine Zahl zwischen 0 und 999999");
    body.append(this.idInput.root);

    const form = this.root.querySelector("form")!;
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      this.create();
    });

    this.modal = new Modal(this.root);
  }

  private create() {
    let nummernkreis = 0;
    try {
      nummernkreis = Number.parseInt(this.nummernkreisInput.getValue() || "");

      if (nummernkreis < 0 || nummernkreis > 99) {
        throw new Error("Nummernkreis muss zwischen 0 und 99 liegen");
      }
    } catch (error) {
      alert("Der Nummernkreis ist ungültig");
      return;
    }

    let unternummernkreis = 0;
    try {
      unternummernkreis = Number.parseInt(
        this.unternummernkreisInput.getValue() || "",
      );

      if (unternummernkreis < 0 || unternummernkreis > 999) {
        throw new Error("Unternummernkreis muss zwischen 0 und 999 liegen");
      }
    } catch (error) {
      alert("Der Unternummernkreis ist ungültig");
      return;
    }

    let id = 0;
    try {
      id = Number.parseInt(this.idInput.getValue() || "");

      if (id < 0 || id > 999999) {
        throw new Error("ID muss zwischen 0 und 999999 liegen");
      }
    } catch (error) {
      alert("Die ID ist ungültig");
      return;
    }

    const nummernkreisString = nummernkreis.toString().padStart(2, "0");
    const unternummernkreisString = unternummernkreis
      .toString()
      .padStart(3, "0");
    const idString = id.toString().padStart(6, "0");
    const projectId = `S${nummernkreisString}${unternummernkreisString}${idString}`;

    this.modal.hide();

    const onFinish = this.getOnFinish();
    onFinish(projectId);
  }

  private getOnFinish(): NewProjectCallback {
    // This should be impossible
    if (this.onFinish === undefined) {
      throw new Error("onFinish is undefined");
    }

    return this.onFinish;
  }

  public open(onFinish: NewProjectCallback) {
    this.onFinish = onFinish;

    this.idInput.setValue("");

    this.modal.show();
  }
}

class ImportPortalModal {
  readonly root: HTMLElement;

  private url: HTMLInputElement;
  private errorAlert: HTMLElement;

  private modal: Modal;
  private onFinish: ImportSchemaCallback | undefined = undefined;

  constructor() {
    this.root = document.createElement("div");
    this.root.classList.add("modal");
    this.root.setAttribute("aria-hidden", "true");
    this.root.setAttribute("tabindex", "-1");

    this.root.innerHTML = `
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <form>
                        <div class="modal-header">
                            <h5 class="modal-title">Aus FIM Portal Importieren</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-3">
                              <label for="url" class="form-label">
                                Füge hier den Link zum Schema aus dem 
                                  <a href="https://fimportal.de/search?resource=schema" target="_blank" class="d-flex-inline flex-row align-items-center gap-1">
                                    FIM-Portal<i class="bi bi-box-arrow-up-right small ms-1"></i></a>
                                ein:
                              </label>
                              <input
                                id="url"
                                class="form-control"
                                type="text"
                                required
                              />
                              <div class="form-text">
                                Der FIM Portal Import unterstützt aktuell nur XDatenfelder 2.0. Alle Daten werden automatisch zu XDatenfelder 3.0.0 konvertiert.
                              </div>
                            </div>
                            <div class="alert alert-danger" role="alert" hidden></div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Abbrechen</button>
                            <button type="submit" class="btn btn-primary">Importieren</button>
                        </div>
                    </form>
                </div>
            </div
        `;

    this.url = this.root.querySelector("#url") as HTMLInputElement;

    this.errorAlert = this.root.querySelector(".alert") as HTMLElement;

    const form = this.root.querySelector("form")!;
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      this.import();
    });

    this.modal = new Modal(this.root);
  }

  private setError(message: string) {
    this.errorAlert.textContent = message;
    this.errorAlert.removeAttribute("hidden");
  }

  private async import() {
    const url = this.url.value;
    const identifier = detectPortalImport(url);
    if (identifier === null) {
      this.setError("Die URL ist keine gültige FIM Portal URL.");
      return;
    }

    this.url.setAttribute("disabled", "true");
    const [fimId, fimVersion] = identifier;

    try {
      const schemaDoc = await documentImport.importSchema(fimId, fimVersion);
      this.modal.hide();

      project.assert(this.onFinish !== undefined);
      this.onFinish(schemaDoc);
    } catch (error) {
      console.warn(error);
      this.url.removeAttribute("disabled");
      this.setError(`Es ist ein Fehler aufgetreten: ${error}`);
    }
  }

  public open(onFinish: ImportSchemaCallback) {
    this.onFinish = onFinish;

    this.url.value = "";
    this.modal.show();
  }
}

async function importXdf2FromPortal(
  backend: LocalBackend,
  fimId: string,
  fimVersion: string,
): Promise<{ fimId: string; fimVersion?: string } | null> {
  try {
    const schemaDoc = await documentImport.importSchema(fimId, fimVersion);
    backend.saveSchemaDocument(schemaDoc);

    if (schemaDoc.schema.type === "arbeitskopie") {
      return {
        fimId: schemaDoc.schema.fimId,
      };
    } else {
      return {
        fimId: schemaDoc.schema.fimId,
        fimVersion: schemaDoc.schema.fimVersion,
      };
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}

function detectPortalImport(location: string): [string, string] | null {
  let url: URL;

  try {
    // Try to parse with current schema, if that fails add https:// and try again
    try {
      url = new URL(location);
    } catch {
      url = new URL(`https://${location}`);
    }
  } catch (error) {
    console.warn("Failed to parse URL", location);
    return null;
  }

  const pathname = url.pathname;
  const parts = pathname.split("/");

  // The first part is always empty
  // What we search for is ["", "schemas", "<id>", "<version>", ...]
  if (parts.length < 4) {
    return null;
  }

  if (parts[0] !== "" || parts[1] !== "schemas") {
    return null;
  }

  const fimId = parts[2];
  const fimVersion = parts[3];

  return [fimId, fimVersion];
}

// The top-level application class
// This class is responsible for managing the different views of the application
// and handling all "global" state.
class App {
  private backend: LocalBackend;
  private container: HTMLDivElement;

  private editor: Editor | null = null;

  constructor() {
    this.backend = LocalBackend.init();
    this.container = document.querySelector<HTMLDivElement>("#app")!;

    window.addEventListener("storage", (_event) => {
      if (this.editor === null) {
        return;
      }

      // TODO: Re-enable syncing over local storage
      /**
       * if (event.key === this.editor.getDocumentId()) {
       * if (event.newValue === null) {
       * console.error(event);
       * throw new Error("Received empty project from local storage.");
       * } else {
       * const newProject: Project = JSON.parse(event.newValue);
       * this.editor.updateProject(newProject);
       * }
       * }
       */
    });
  }

  public static async mount() {
    const app = new App();

    const portalImport = detectPortalImport(window.location.href);
    if (portalImport !== null) {
      const [fimId, fimVersion] = portalImport;

      const schema = await importXdf2FromPortal(app.backend, fimId, fimVersion);
      if (schema !== null) {
        app.loadAndOpenDocument(schema.fimId, schema.fimVersion);
      }
    }

    app.showHome();
  }

  private showHome() {
    // TODO: Listen to history changes
    history.pushState({}, "Home", "/");

    this.container.replaceChildren(
      renderPicker(this.backend, (schema) => {
        this.loadAndOpenDocument(schema.fimId, schema.fimVersion);
      }),
    );
  }

  private async loadAndOpenDocument(
    fimId: string,
    fimVersion: string | undefined,
  ) {
    let document: project.Document;
    try {
      document = this.backend.loadSchemaDocument(fimId, fimVersion);
    } catch (error) {
      alert(`Dokument konnte nicht geöffnet werden: ${error}`);
      return;
    }

    this.openDocument(document);
  }

  private async openDocument(document: project.Document) {
    const store = new ProjectStore(document, this.backend);
    this.editor = new Editor(store, () => {
      this.showHome();
    });
    this.container.replaceChildren(this.editor.root);
  }
}

App.mount();
